var map = {
	"./CARNET1.mp4": "2d34",
	"./CARNET3.mp4": "ae33",
	"./Correo.png": "d9a9",
	"./Dilu_Pereda.webp": "d077",
	"./E.png": "ddc2",
	"./E1.png": "6b23",
	"./G.png": "6f51",
	"./G1.png": "0dcd",
	"./IngGiovaniPernia.png": "ad88",
	"./Ing_Giovany_Pernia.webp": "58e7",
	"./Ingenierito transformer volteado 1.png": "feaa",
	"./J.png": "b9ab",
	"./J1.png": "eae7",
	"./L.png": "d6c5",
	"./L1.png": "76d6",
	"./Link.webp": "1ca0",
	"./MUJER-INICIO-1.png": "7776",
	"./MasterClass/Imagen1.webp": "7fec",
	"./MasterClass/Imagen2.webp": "a48d",
	"./MasterClass/MC1.webp": "56f7",
	"./MasterClass/MC2.webp": "36ff",
	"./MasterClass/MC3.webp": "5b12",
	"./MasterClass/MC4.webp": "b04e",
	"./MasterClass/MC5.webp": "86c8",
	"./MasterClass/MC6.webp": "f5e9",
	"./MasterClass/MC7.webp": "769b",
	"./MasterClass/MC8.webp": "c308",
	"./Ubicacion.png": "7cb7",
	"./a123-1.webp": "b493",
	"./a123-2.webp": "7699d",
	"./a123-5.webp": "ac5b",
	"./a123-6.webp": "f7f7",
	"./a123-7.webp": "f362",
	"./a123_1.webp": "98ab",
	"./a123_2.webp": "9344",
	"./a123_3.webp": "1e6f",
	"./a123_4.webp": "cb25",
	"./a123_5.webp": "3328",
	"./a123_6.webp": "fd11",
	"./a123_7.webp": "1bfe",
	"./bancodelanacio-logo.webp": "7688",
	"./banner-1.webp": "4ed6",
	"./banner-2.webp": "8ea5",
	"./banner-3.webp": "7eab",
	"./banner-4.webp": "29de",
	"./banner-5.webp": "21bf",
	"./bbva-logo.webp": "fca9",
	"./bbva.webp": "162d",
	"./bcp-logo.webp": "5b02",
	"./bcp.webp": "d93f",
	"./box-arrow-up-right.svg": "5ae8",
	"./candado.png": "b1db",
	"./carnetB.png": "b8a2",
	"./carnetW.png": "08ff",
	"./cart4.svg": "9ad8",
	"./certificado.jpg": "11da",
	"./certificado.png": "284f",
	"./certificado.webp": "a669",
	"./correo-electronico.png": "06f6",
	"./cropimage3431.webp": "87bb",
	"./culqi.webp": "2e18",
	"./doc.png": "405c",
	"./emilio.png": "0ef3",
	"./expandir.png": "2aae",
	"./fb_1@4x.png": "bd1e",
	"./fluentright.svg": "4d39",
	"./foto1.jpg": "c05d",
	"./foto2.jpg": "7c7e",
	"./free.png": "9c34",
	"./gg_check-o.png": "5e46",
	"./giovanycard.png": "f7b8",
	"./global.css": "150b",
	"./ia_logo_inicio.png": "0ba2",
	"./im1.webp": "aedb",
	"./image-56.webp": "d4d1",
	"./image-conoce.webp": "5d5a",
	"./img/Ingenierito animado partes copia LOGO DIFERENTE 1 2.png": "cbfa",
	"./img/Ingenierito.png": "667d",
	"./img/account_box.png": "c0b1",
	"./img/attach_file.png": "f2e8",
	"./img/close.png": "04b3",
	"./img/cross.svg": "ed72",
	"./img/description.png": "cf7d",
	"./img/edit.svg": "66d5",
	"./img/editar-texto.png": "08c1",
	"./img/editar.png": "b749",
	"./img/eliminar.png": "1a41",
	"./img/expand-orange.svg": "5c6d",
	"./img/expand-recommend.svg": "9141",
	"./img/expandir.png": "94b6",
	"./img/expandirchat.png": "f2bb",
	"./img/flecha.png": "03ecc",
	"./img/historial.png": "bb51",
	"./img/imagesmode.png": "4108",
	"./img/location_on.png": "f7b3",
	"./img/mic.png": "aeac",
	"./img/pantalla.png": "4a7c",
	"./img/photo_camera.png": "c958",
	"./img/send.png": "fbe7",
	"./img/x.png": "5610",
	"./img48.png": "afc3",
	"./img49.png": "68c9",
	"./img50.png": "f260a",
	"./imge2.webp": "6f46",
	"./in_1@4x.png": "9d3f",
	"./iniciar-curso.webp": "20ac",
	"./inprocal-oficinas.jpg": "272b",
	"./instagram_1@4x.png": "137b",
	"./jorge.png": "6f60",
	"./logo-aula.png": "6975",
	"./logo-footer.png": "37db",
	"./logo-inprocal.png": "4e66",
	"./logo-ipssoma-navidd.png": "3b08",
	"./logo-oficial-segundo-simposio.webp": "b2dc",
	"./logo.png": "cf05",
	"./logo.webp": "4841",
	"./logoips.png": "5f45",
	"./logro1.webp": "8050",
	"./logro2.webp": "53bd",
	"./logro3.webp": "338c",
	"./logro4.webp": "0d14",
	"./logro5.webp": "6317",
	"./luis.png": "6204",
	"./manual.webp": "057b",
	"./marca-de-verificacion.png": "39ec",
	"./metodologia.webp": "f700",
	"./minicertificate.svg": "d237",
	"./minilaptop.svg": "4b0c",
	"./monitor.png": "7fea",
	"./nacion.webp": "20d4",
	"./no-video.png": "7634",
	"./perfil-del-usuario.png": "96cb",
	"./phone-outline-icon.svg": "7699",
	"./play.svg": "5830",
	"./portada-consultoria.webp": "62a8",
	"./preguntas-frecuentes.webp": "41e6",
	"./presentacion_horizontal.mp4": "7016",
	"./presentacion_vertical.mp4": "54a5",
	"./profesor_1.webp": "2fc8",
	"./profesor_2.webp": "6ff9",
	"./quienes_somos.mp4": "499f",
	"./regalo1.webp": "7476",
	"./regalo2.webp": "69b3",
	"./s12-1-copia.webp": "6edb",
	"./s12_1-copia.webp": "0164",
	"./scotia.webp": "ef66",
	"./scotiabank-logo.webp": "2d33",
	"./select-down-arrow.svg": "53e4",
	"./shoppingcar.svg": "fbc8",
	"./simposio_nov.webp": "b176",
	"./teacher.png": "54d6",
	"./team-1.webp": "4355",
	"./team-2.webp": "d878",
	"./team-3.webp": "16c6",
	"./telefono.png": "0c75",
	"./tiktok_1@4x.png": "7643",
	"./transf.webp": "765e",
	"./user-outline-icon.svg": "2f14",
	"./view.png": "b9d6",
	"./wtsp.svg": "3b51",
	"./wtspicon.png": "4290",
	"./yape-logo.webp": "69c8",
	"./youtube_1@4x.png": "f81b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";